// extracted by css-extract-rspack-plugin
export default {"viewDocument":"viewDocument-N0vsCy","viewHint":"viewHint-Mt0kfw text-sm","bold":"bold-nZY5up"};